import { MI } from "../init";
import MadnesTween from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @param {MadnesGroup} group
 * @param {GameAssets} assets
 * @returns {Alchemist}
 */
export default function Alchemist(group, assets) {

    /** @type {MadnesGroup} */
    this._group = group;

    /** @type {GameAssets} */
    this._assets = assets;

    /** @type {MadnesObject} */
    this._body;

    /** @type {MadnesObject} */
    this._hand;

    /** @type {MadnesTween} */
    this._tweenStand;

    /** @type {MadnesObject} */
    this._shine;

    this._sBodyX = 0;
    this._sBodyY = 0;
};

Alchemist.prototype.createShuffling = function () {

    this._sBodyX = MI.getWi() - 50;
    this._sBodyY = MI.getHe() - 5;

    this._body = MI.addImg(this._sBodyX + 300, this._sBodyY, "alchemist_shuffling_atlas");
    this._body.setFrameName("Alchemist_shuffling");
    this._body.setAnchor(1, 1);
    this._body.setAngle(4);

    this._group.add(this._body);

    this._hand = MI.addImg(-176, -250, "alchemist_shuffling_atlas").setFrameName("Alchemist_shuffling_hand");
    this._hand.setAnchor(1, 1);
    this._hand.setAngle(-40);
    this._body.addChild(this._hand);

    this._shine = MI.addImg(MI.getWi() - 192, MI.getHe() - 262, "shuffling_shine_atlas");
    this._shine.setVisible(false);
    this._shine.setAnchor(1, 1);
    this._shine.setScale(1.80, 1.80);
    this._shine.setBlend("ADD");
    //this._shine.setAngle(7);

    this._shine.createAnims();
    this._shine.anims.add("shine", MI.generateFrameNames("Wild_shuffle_shine_", 0, 63, "", 5));

    this._group.add(this._shine);
};

/**
 * @returns {Promise}
 */
Alchemist.prototype.playShuffling = function () {

    var _self = this;

    //	MI.createTimer().add(function() {
    MI.controls.hideAllBtns();
    //	}, 1000);



    return new Promise(function (res) {

        MI.addTween().to(_self._body, { 'x': _self._sBodyX }, {
            'delay': 0,
            'duration': 1000
        });

        MI.addTween().to(_self._body, { 'y': _self._sBodyY - 12 }, {
            'delay': 0,
            'duration': 200,
            'easing': MadnesTween.getEasing("sinusoidal_in_out"),
            'yoyo': true,
            'count': 3,
            'callback': function () {
                _self._tweenStand = MI.addTween().to(_self._body, { 'y': _self._sBodyY - 4 }, {
                    'duration': 1000,
                    'easing': MadnesTween.getEasing("sinusoidal_in_out"),
                    'count': -1,
                    'yoyo': true,
                });
            }
        });


        MI.createTimer().add(function() {
            res();
        }, 2500);

        MI.createTimer().add(function() {

            _self._shine.setVisible(true);
            _self._shine.anims.play("shine", 40);
            _self._shine.anims.addOnComplete(function() {
                _self._shine.destroy();
                _self._shine = null;
            });

            MI.addTween().to(_self._body, { 'angle': -2 }, {
                'duration': 300,
            });

            MI.addTween().to(_self._hand, { 'angle': 30 }, {
                'duration': 400,
                'callback': function () {

                    MI.addTween().to(_self._body, { 'angle': 1 }, { 'duration': 300 });
                    MI.addTween().to(_self._hand, { 'angle': -20 }, { 'duration': 600 });

                    MI.createTimer().add(function () {

                        MI.addTween().to(_self._body, { 'y': _self._sBodyY + 12 }, {
                            // 'delay': 2600,
                            'onStart': function () {
                                _self._tweenStand.stop();
                                _self._tweenStand = null;
                            },
                            'duration': 300,
                            'easing': MadnesTween.getEasing("sinusoidal_in_out"),
                            'yoyo': true,
                            'count': 1
                        });

                        MI.addTween().to(_self._hand, { 'angle': -30 }, {
                            'duration': 1000,
                        });

                        MI.addTween().to(_self._body, { 'x': _self._sBodyX + 300 }, {
                            // 'delay': 2600,
                            'duration': 1000,
                            'callback': function () {
                                _self._body.destroy();
                            }
                        });

                    }, 2600);
                }
            });
        }, 1000);
    });
};

Alchemist.prototype.createChanging = function () {

    this._body = MI.addImg(MI.getWi() + 220, MI.getHe(), "alchemist_changing_atlas");
    this._body.setFrameName("Alchemist_changing");
    this._body.setAnchor(1, 1);
    this._body.setAngle(0);
    this._group.add(this._body);

    this._hand = MI.addImg(0, -270, "alchemist_changing_atlas").setFrameName("Alchemist_changing_hand");
    this._hand.setAnchor(1, 0.5);

    this._body.addChild(this._hand);
};

/**
 * @param {number} color
 * @param {Function=} onOpen
 * @returns {Promise}
 */
Alchemist.prototype.playChanging = function (color, onOpen) {

    var _self = this;

    if (typeof onOpen === 'undefined') { onOpen = function () { }; }

    //MI.controls.hideAllBtns();

    return new Promise(function (res) {

        MI.addTween().to(_self._body, { 'y': MI.getHe() - 16 }, {
            'delay': 0,
            'duration': 200,
            'easing': MadnesTween.getEasing("sinusoidal_in_out"),
            'count': 1,
            'yoyo': true,
            'callback': function () {
                _self._tweenStand = MI.addTween().to(_self._body, { 'y': MI.getHe() - 4 }, {
                    'duration': 800,
                    'easing': MadnesTween.getEasing("sinusoidal_in_out"),
                    'count': -1,
                    'yoyo': true,
                    'callback': function () {

                        var pos = _self._body.getPosY();

                        _self._tweenStand.stop();
                        _self._tweenStand = MI.addTween().to(_self._body, { 'y': pos + 8 }, {
                            'duration': 300,
                            'easing': MadnesTween.getEasing("quintic_out"),
                            'callback': function () {
                                _self._tweenStand = MI.addTween().to(_self._body, { 'y': pos }, {
                                    'duration': 400,
                                    'easing': MadnesTween.getEasing("cubic_out"),
                                    'callback': function () {
                                        _self._tweenStand = MI.addTween().to(_self._body, { 'y': pos + 4 }, {
                                            'duration': 1000,
                                            'easing': MadnesTween.getEasing("sinusoidal_in_out"),
                                            'count': -1,
                                            'yoyo': true,
                                        });
                                    }
                                });
                            }
                            //'yoyo': true
                        });
                    }
                });
            }
        });

        MI.addTween().to(_self._body, { 'x': MI.getWi() - 20 }, {
            'delay': 0,
            'duration': 500,
            'callback': function () {
                MI.addTween().to(_self._hand, { 'angle': 30 }, {
                    'delay': 200,
                    'duration': 300,
                    'easing': MadnesTween.getEasing("back_out"),
                    'onStart': function () {
                        _self._assets.dust(1110, 430, 1, 0, color, 0);
                        onOpen();
                    },
                    'callback': function () {

                        MI.addTween().to(_self._hand, { 'angle': 25 }, {
                            'duration': 300,
                            'callback': res
                        });
                    }
                });
            }
        });
    });
};

Alchemist.prototype.changingCloseBottle = function () {

    MI.addTween().to(this._hand, { 'angle': 10 }, {
        'duration': 500
    });

};

/**
 * @param {number} color
 */
Alchemist.prototype.hideChanging = function (color) {

    var _self = this;

    _self._assets.dust(1100, 350, 4, 100, color, 100);
    _self._assets.dust(1100, 550, 4, 100, color, 100);

    MI.addTween().to(_self._body, { 'alpha': 0 }, {
        'duration': 1000,
        'callback': function () {
            _self._tweenStand.stop();
            _self._tweenStand = null;
            _self._destroy();

            //MI.controls.showAllBtns();
        }
    });
};

Alchemist.prototype._destroy = function () {
    this._body.destroy();
};